import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCreditCard, faHandsHoldingDollar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
const DisputesTransactionTypeContainer = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
const DisputesTransactionIcon = styled(FontAwesomeIcon) `
  color: ${({ theme }) => theme.colors.cyanBlue};
  width: 24px;
  height: 24px;
`;
const DisputesTransactionTypeText = styled.span `
  color: ${({ theme }) => theme.colors.cyanBlue};
  margin-top: ${({ theme }) => theme.spacing.small}px;
  font-size: ${({ theme }) => theme.fontSizes.xsmall}px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold}px;
`;
const TransactionTypeIcons = {
    PURCHASE: faCreditCard,
    REFUND: faHandsHoldingDollar
};
const DisputesTransactionTypeIcon = ({ className, title, type }) => {
    const icon = type ? TransactionTypeIcons[type] : faCreditCard;
    return (_jsxs(DisputesTransactionTypeContainer, Object.assign({ className: className }, { children: [_jsx(DisputesTransactionIcon, { icon: icon }), _jsx(DisputesTransactionTypeText, { children: title })] })));
};
export default DisputesTransactionTypeIcon;
//# sourceMappingURL=DisputesTransactionTypeIcon.js.map